import api from '../auth';
const slug = 'api/params/';

const ParamService = () => {
    const getParams = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getParamsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getParam = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteParam = (id) => {
        return api
            .delete(slug + `param/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createParam = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateParam = (id, data) => {
        return api.put(slug + `param/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyParam = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getParams,
        getParamsLazy,
        getParam,
        deleteParam,
        createParam,
        updateParam,
        getOptions,
        copyParam
    };
};

export default ParamService;
